import React, { useState, useEffect } from "react";
import about from "../../assets/image/about_nha_pg_logo.png";

const ConfirmDetail = ({ setIsconfirm, patient, setPatient }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [confirmdetail, setConfirmDetail] = useState(null);

  useEffect(() => {
    try {
      const storedData = localStorage.getItem("selectedIndex");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setConfirmDetail(parsedData);
      }
    } catch (error) {
      console.error("Error parsing confirmdetail from localStorage:", error);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isChecked) {
      setIsconfirm(true);
    }
  };

  const handleBack = () => {
    setPatient(null);
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Confirm Details</h3>
                <form onSubmit={handleSubmit} className="pt-5">
                  <div className="col-ms-10 col-lg-10 col-xl-10 col-sm-10 col-xs-10">
                    <div className="row">
                      <div className="">
                        <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                          {confirmdetail ? (
                            <div className="d-flex align-items-center bg-white p-3 mb-2 rounded">
                              <div
                                className="avatar-initial me-3 d-flex align-items-center justify-content-center text-white fw-bold"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                  fontSize: "20px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {confirmdetail?.fname?.charAt(0)}
                              </div>
                              <div>
                                <h5 className="mb-1 patient-name">
                                  {confirmdetail?.fname} {confirmdetail?.lname}
                                </h5>
                                <div className="d-flex flex-wrap gap-2 patient-self">
                                  <span>self |</span>
                                  <span>{confirmdetail?.gender} |</span>
                                  <span>{confirmdetail?.dob}</span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <p>No patient selected.</p>
                          )}

                          <div className="d-flex">
                            <input
                              type="checkbox"
                              className="form-check-input checkbox-color"
                              id="flexCheckDefault"
                              checked={isChecked}
                              onChange={() => setIsChecked(!isChecked)}
                            />
                            <label
                              className="form-check-label ps-2 mb-2"
                              htmlFor="flexCheckDefault"
                            >
                              I Agree to{" "}
                              <a className="resend-otp" href="#">
                                Terms & Conditions
                              </a>{" "}
                              And{" "}
                              <a className="resend-otp" href="#">
                                Privacy Policy
                              </a>{" "}
                              Dr Lal Pathlabs to Create/Link My ABHA Address.
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-ms-6 col-lg-6 col-xl-6 col-sm-6 col-xs-6">
                        <button type="submit" className="back-btn">
                          Back
                        </button>
                      </div>
                      <div className="col-ms-6 col-lg-6 col-xl-6 col-sm-6 col-xs-6">
                        <button
                          type="submit"
                          className={`confirm-btn ${
                            !isChecked ? "bg-disable" : ""
                          }`}
                          disabled={!isChecked}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="nha-logo-container">
                  <span>APPROVED BY NHA</span>
                 <img src={about} alt="NHA Logo" className="nha-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConfirmDetail;
